import { Routes } from "@angular/router";
import { HealthFirstLayoutComponent } from "./components/health-first-layout/health-first-layout.component";
import { HfPlansPageComponent } from "./components/hf-plans-page/hf-plans-page.component";
import { HfHomeComponent } from "./components/hf-home/hf-home.component";
import { HfCalculatorPageComponent } from "./components/hf-calculator-page/hf-calculator-page.component";
import { HfPriceBreakupComponent } from "./components/hf-price-breakup/hf-price-breakup.component";
import { HfRiskMeterPageComponent } from "./components/hf-risk-meter-page/hf-risk-meter-page.component";
import { AuthGuard } from "../shared/guards/auth/auth.guard";
import { HfThankyouPageComponent } from "./components/hf-thankyou-page/hf-thankyou-page.component";

export const HEALTH_FIRST_ROUTES: Routes = [
  {
    path: '',
    component: HealthFirstLayoutComponent,
    children: [
      {
        path: '',
        component: HfHomeComponent,
        data: {
          page_name: 'healthfirst_homepage'
        },
      },
      {
        path: 'plans',
        component: HfPlansPageComponent,
        data: {
          page_name: 'chooseplan'
        }
      },
      {
        path: 'calculator',
        component: HfCalculatorPageComponent,
        data: {
          page_name: 'healthfirst_calculator'
        }
      },
      {
        path: 'price-breakup',
        component: HfPriceBreakupComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'risk-meter',
        component: HfRiskMeterPageComponent
      },
      {
        path: 'thankyou',
        component: HfThankyouPageComponent,
        data: {
          page_name: 'hf_thankyou'
        }
      }
    ]
  }
]